import { GetApp } from "../../App"
import { TimelineFade } from "../../Components/TimelineFade"
import { TripView } from "../TripView"
import { CruiseContentViewProps } from "./Params"

export function CruiseContentView({ trips }: CruiseContentViewProps) {
  const app = GetApp();
  const t = app.getT("CruiseView");

  return (
    <div className="CruiseView-content">
      {trips.length > 0 && <TimelineFade before={true} count={8} width={18} />}
      {trips.map((trip) => <TripView key={`trip-${trip.id}`} trip={trip} />)}
      {trips.length < 1 && <div className="empty">{t("empty")}</div>}
      {trips.length > 0 && <TimelineFade before={false} width={18} />}
    </div>
  );
}
